exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ncanvas[data-v-150c29c9] {\r\n  width: 100% !important;\r\n  height: 300px !important;\n}\r\n", ""]);

// exports
